import { ReactQueryStaleTime } from '@openx/constants/react-query.ts';
import { type OptionsMap, ParameterizedOptionsType } from '@openx/types/options.ts';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { prepareMapBy } from '../lib/prepareMapBy.ts';
import { fetchOptions } from '../state/parameterizedOptions/api.ts';

export function useOpenAudiencesOptionsFetch(accountUid: string) {
  const { t } = useTranslation();

  const {
    isLoading: isAudiencsesLoading,
    data: audiences,
    refetch: refetchAudiences,
  } = useQuery<OptionsMap>({
    enabled: false,
    meta: {
      errorMessage: t('Failed to fetch Open Audiences'),
    },
    queryFn: async () => {
      if (!accountUid) {
        return {};
      }
      const list = await fetchOptions({
        params: { account_uid: accountUid },
        type: ParameterizedOptionsType.OPEN_AUDIENCES,
      });
      return prepareMapBy(list, 'id');
    },
    queryKey: [ParameterizedOptionsType.OPEN_AUDIENCES, accountUid],
    staleTime: ReactQueryStaleTime.MINUTES_15,
  });

  return {
    audiences: audiences || {},
    isAudiencsesLoading,
    refetchAudiences,
  };
}
